import { z } from "zod";

import { TEAM_MEMBER_VALUES } from "~/common/constants";
import { phoneNumberSchema } from "~/common/schemas/verificationCode";
import { userPermissionSchema } from "./permissions";

export const teamMemberSchema = z.object({
  acuity_client_id: z.string().optional(),
  email: z.email(),
  id: z.uuid(),
  last_name: z.string(),
  name: z.string(),
  patients_count: z.number(),
  phone_number: phoneNumberSchema,
  preferred_reference: z.string().optional(),
  profile_picture_path: z.string().optional(),
  signature_name: z.string().optional(),
  type: z.enum(TEAM_MEMBER_VALUES),
  user_permissions: z.array(userPermissionSchema),
});
